import React from 'react'
import { Card, Typography } from '@telavita-core/react-design-kit'

import LineSeparator from 'components/LineSeparator'

import { ReactComponent as EmailIcon } from 'static/svg/talk-to-us-card-icons/email-icon.svg'
import { ReactComponent as ForumIcon } from 'static/svg/talk-to-us-card-icons/forum-icon.svg'
import { ReactComponent as HeadsetIcon } from 'static/svg/talk-to-us-card-icons/headset-icon.svg'
import { ReactComponent as WhatsAppIcon } from 'static/svg/talk-to-us-card-icons/whatsapp-icon.svg'

import * as S from './styles'

interface ItemProps {
  icon?: React.FC
  title: string
  children: React.ReactNode
}

const Item = ({ icon, title, children}: ItemProps) => {
  const Icon = icon

  return (
    <S.Item>
      {Icon ? <Icon /> : <div style={{ width: 24 }} />}
      <S.TextWrapper>
        <Typography variant='content2'>
          {title}
        </Typography>
        {typeof children === 'string'
          ? (
            <Typography variant='content3' customClassName='subtitle'>
              {children}
            </Typography>
          ) 
          : children
        }
      </S.TextWrapper>
    </S.Item>
  )
}

export const TalkToUsCard = (): JSX.Element => {
  return (
    <Card
      variant='regular'
      customClassName='ProfessionalHome__Card'  
    >
      <Typography variant='content1' weight='bolder'>
        Fale conosco
      </Typography>

      <S.Container>
        <Item
          icon={WhatsAppIcon}
          title='(11) 5039-6007'
          children='WhatsApp'
        />
        
        <Item
          icon={EmailIcon}
          title='profissionais@telavita.com.br'
          children='Gestão de profissionais'
        />

        <Item
          title='psis.financeiro@telavita.com.br'
          children='Financeiro'
        />

        <Item
          icon={HeadsetIcon}
          title='Horários de atendimento'
        >
          <Typography variant='content2' weight='bold'>
            SAC: <span>8h às 19h</span>
          </Typography>
          <Typography variant='content2' weight='bold'>
            Gestão de profissionais: <span>8h às 18h</span>
          </Typography>
        </Item>

        <LineSeparator 
          lineColor="#e2e2e2"
          lineHeight="1px"
          lineMargin="10px 0"
          lineWidth="100%"
        />

        <Item
          icon={ForumIcon}
          title='Plantão Telavita'
        >
          <S.LinkWrapper>
            <div>
              <Typography variant='content2' weight='bold'>
                Toda quarta <span className='exception'>(exceto feriados)</span>
              </Typography>
              <Typography variant='content2'>
                10h às 11h
              </Typography>
            </div>
            <S.Link
              href={process.env.REACT_APP_MEET_TALK_WITH_TELAVITA_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Entrar  
            </S.Link>
          </S.LinkWrapper>
        </Item>
      </S.Container>
    </Card>
  )
}